import { createTheme } from '@mui/material';

import { componentsConfigs } from './components';
import { fontFamily } from './constants/fonts';
import { layoutConfigs } from './layout';
import { paletteConfigs } from './palette';
import { shadowsConfigs } from './shadows';
import { getTypographyConfigs } from './typography';

export const mockTheme = createTheme({
  components: componentsConfigs,
  typography: getTypographyConfigs(fontFamily.primary),
  palette: paletteConfigs,
  shadows: shadowsConfigs,
  ...layoutConfigs,
});

export const defaultTheme = createTheme({
  components: componentsConfigs,
  typography: getTypographyConfigs(fontFamily.primary),
  palette: paletteConfigs,
  shadows: shadowsConfigs,
  ...layoutConfigs,
});
